import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import AdminCreate from "../components/AdminCreate/AdminCreate";
import { createAdmin } from "../actions/admincreate";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.adminCreate.isFetching,
    response: state.adminCreate.response,
    error: state.adminCreate.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createAdmin,
      fetchUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminCreate);
